// DropZone — File drop / pick zone with image+video preview. Extracted from
// PublishAnalysisModal.jsx. Receives the full file-handling surface so the
// parent retains state ownership and validation logic.
import React from "react";
import { Image as ImageIcon, X as XIcon } from "lucide-react";

export const DropZone = ({
  file,
  preview,
  isVideo,
  dragActive,
  setDragActive,
  onDrop,
  onPick,
  onClear,
  inputRef,
  ui,
}) => (
  <div
    onDragOver={(e) => { e.preventDefault(); setDragActive(true); }}
    onDragLeave={() => setDragActive(false)}
    onDrop={onDrop}
    onClick={() => inputRef.current?.click()}
    className={`mt-5 cursor-pointer rounded-2xl border-2 border-dashed p-4 text-center transition-colors ${
      file
        ? "border-emerald-400/50 bg-emerald-400/[0.04]"
        : dragActive
        ? "border-orange-400/60 bg-orange-400/[0.06]"
        : "border-white/15 bg-white/[0.02] hover:border-white/30"
    }`}
    data-testid="shadow-publish-drop"
  >
    {preview ? (
      <div className="relative">
        {isVideo ? (
          <>
            <video
              src={preview}
              muted
              autoPlay
              loop
              playsInline
              className="block h-auto w-full rounded-xl"
              data-testid="shadow-publish-video-preview"
            />
            <span className="pointer-events-none absolute left-2 bottom-2 inline-flex items-center gap-1 rounded border border-cyan-400/30 bg-black/70 px-2 py-0.5 font-mono text-[9px] font-black uppercase tracking-[0.1em] text-cyan-300 backdrop-blur">
              {ui.pam_video_badge}
            </span>
          </>
        ) : (
          <img src={preview} alt="preview" className="block h-auto w-full rounded-xl" />
        )}
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); onClear(); }}
          className="absolute right-2 top-2 rounded-full border border-white/20 bg-black/70 p-1 text-white/75 hover:text-white"
        >
          <XIcon className="h-3 w-3" />
        </button>
      </div>
    ) : (
      <div className="flex flex-col items-center gap-2 py-6">
        <ImageIcon className="h-7 w-7 text-white/35" />
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/70">
          {ui.pam_dropzone_title}
        </p>
        <p className="text-[10px] text-white/35">
          {ui.pam_dropzone_sub}
        </p>
      </div>
    )}
    <input
      ref={inputRef}
      type="file"
      accept="image/jpeg,image/png,image/webp,video/mp4,video/quicktime,video/webm"
      className="hidden"
      onChange={(e) => onPick(e.target.files?.[0])}
      data-testid="shadow-publish-input-file"
    />
  </div>
);

export default DropZone;
